import { Routes } from '@angular/router';
import { AuthCallbackComponent } from './views/auth/auth-callback.component';
import { CyberArkCallbackComponent } from './views/auth/cyberark-callback.component';

export const routes: Routes = [
  { path: '', loadChildren: () => import('./views/painel/painel.module').then(m => m.PainelModule) },
  { path: 'login', loadChildren: () => import('./views/login/login.module').then(m => m.LoginModule) },
  { path: 'Autorizacao/:token', loadChildren: () => import('./views/autorizacao/autorizacao.module').then(m => m.AutorizacaoModule) },
 {
  path: 'loginsuccess',
  component: AuthCallbackComponent
},
 {
  path: 'cyberark-callback',
  component: CyberArkCallbackComponent
}
];
